// extracted by mini-css-extract-plugin
export default {"libraryscreen":"e160a7230f68d0968c47","sidebar":"ac3ad9e362b760f12547","appicon":"e7ded22aa3cfc8df6f42"};